import { action, makeObservable, observable, toJS } from "mobx";
import { VariationTypeStore } from "./variationType";
import { VariantStore } from "./variant";

export class CurrentCatalogItemStore {
    @observable id;
    @observable name;
    @observable isPremium;
    @observable type;
    @observable categoriesIds = [];
    @observable partnerId;
    @observable metadata = {
        isContainer: false,
        canBeContained: false,
        isNonCollidable: false,
        isNonRotatable: false,
        priceUnit: 0,
    };

    variants;
    variationsTypes;


    constructor(currentUserStore, itemData) {
        makeObservable(this);
        if (typeof itemData === 'undefined') {
            this.variationsTypes = observable.array([]);
            this.variants = observable.array([]);
            this.partnerId = currentUserStore.user?.uid ?? null;
        } else {
            this.id = itemData.id;
            this.name = itemData.name;
            this.isPremium = itemData.isPremium;
            this.type = itemData.type;
            this.categoriesIds = itemData.categoriesIds;
            this.creationDate = itemData.creationDate;
            this.updatedOn = itemData.updatedOn;
            this.isReady = itemData.isReady;
            this.partnerId = itemData.partnerId;

            this.metadata.isContainer = itemData.metadata.isContainer;
            this.metadata.canBeContained = itemData.metadata.canBeContained;
            this.metadata.isNonCollidable = itemData.metadata.isNonCollidable;
            this.metadata.isNonRotatable = itemData.metadata.isNonRotatable;
            this.metadata.priceUnit = itemData.metadata.priceUnit;

            this.variants = observable.array(itemData.variants.map(data => new VariantStore(data)));
            this.variationsTypes = observable.array(itemData.variationsTypes.map(data => new VariationTypeStore(data)));
        }
    }

    @action.bound addVariationsType = (data) => {
        this.variationsTypes.push(new VariationTypeStore(data, this.variationsTypes.length === 0));
    };

    @action.bound removeVariationsType = (id) =>
        this.variationsTypes.splice(this.variationsTypes.findIndex(variationsType => variationsType.id === id), 1);

    @action.bound setPrimaryVariationsType = (id) =>
        this.variationsTypes.forEach(variationsType => variationsType.setIsPrimary(variationsType.id === id));

    @action.bound setProp = (key, value) => this[key] = value;

    @action.bound addCategory = (id) => {
        if (this.categoriesIds.includes(id)) {
            console.log(`Trying to add the same category twice ${id}`);
        } else {
            this.categoriesIds.push(id);
        }
    }

    @action.bound removeCategory = (index) => this.categoriesIds.splice(index, 1);

    @action.bound updateCategory = (index, newId) => this.categoriesIds.splice(index, 1, newId);

    @action.bound setMetadataProp = (key, value) => this.metadata[key] = value;

    @action.bound constructVariant = () => {
        const variantToAdd = new VariantStore();
        this.variants.push(variantToAdd);
        return variantToAdd;
    }

    @action.bound deleteVariant = (id) =>
        this.variants.splice(this.variants.findIndex(variant => variant.id === id), 1);

    toJSON = () => {
        const asJS = toJS(this);
        delete asJS.toJSON;

        if (asJS.categoriesIds.includes(undefined)) {
            asJS.categoriesIds.splice(this.categoriesIds.indexOf(undefined), 1);
        }

        return asJS;
    }
}
